export default __webpack_public_path__ + "static/altium-designer-92f9eb5a857cf8a66f40a9d18e042628.svg";